<div class="form-check" [id]="'dfe32d08-c4a3-4ed2-8b8d-a36e11f86103' + id" *ngFor="let option of selectionOptions; let i = index">
  <input class="form-check-input" type="radio" [id]="id + '-' + i" [checked]="i === selectedMonth" (change)="onMonthSelect(i)" [name]="id" />
  <label [for]="id + '-' + i">
    {{
      (includeCurrentMonth && i === 0
        ? 'uiTools.dateSelection.upcomingMonthSelector.currentMonth'
        : (!includeCurrentMonth && i === 0) || (includeCurrentMonth && i === 1)
        ? 'uiTools.dateSelection.upcomingMonthSelector.nextMonth'
        : 'uiTools.dateSelection.upcomingMonthSelector.followingMonth'
      ) | transloco
    }}<br />
    <span class="text-n-40 p-0">{{ option | monthAndYear | async }}</span></label
  >
</div>
